import { useUI } from "providers/UIProvider"

import { IReservationsToolbarProps } from "./ReservationsToolbarTypes"

import { Box, Button, Flex, Text } from "@chakra-ui/react"

import Heading from "components/UI/atoms/Heading"
import Checkbox from "components/UI/atoms/Checkbox"
import Icon from "components/UI/atoms/Icon";
import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"
import { IStatusGroup } from "types/reservation"
import {
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
} from "@chakra-ui/react"
import { IVehicleBodyTypeGroups, IWashersForFilter } from "providers/ReservationsProvider/ReservationsProviderTypes"
import DateRangePicker from "./DateRangePicker/DateRangePicker"
import { useEffect, useState } from "react"

const ReservationsToolbar: React.FC<IReservationsToolbarProps> = () => {
  const { T } = useUI()
  const { boxTotals,
    statusGroups,
    washersForFilter,
    selectedStatuses,
    selectedVehicleTypes,
    handleStatusCheckboxClick,
    handleWashersFilter,
    handleVehicleTypeCheckBox,
    handleBoxCountCheckbox,
    selectedBoxes,
    selectedWashers,
    vehicleBodyTypeGroups,
    boxCount,
    handleSelectDatesClick,
    selectedDates,
    handleClearAllFilters
  } = useReservationsContext();


  const [isDateSelected, setIsDateSelected] = useState(false);



  const arrayTransformedBoxCount = Array.from({ length: boxCount }, (_, i) => i + 1)

  //boxes
  const lastIndex = selectedBoxes.length - 1;
  const lastSelectedItem = selectedBoxes[lastIndex];
  //statuses
  const latestSelectedStatus = selectedStatuses[selectedStatuses.length - 1];
  const lastSelectedStatus = statusGroups.find(status => status.status === latestSelectedStatus)
  //selectedCategories
  const latestSelectedCategory = selectedVehicleTypes[selectedVehicleTypes.length - 1];
  const lastSelectedCategory = vehicleBodyTypeGroups.find(category => category.id === latestSelectedCategory)
  //selectedWashers
  const latestSelectedWasher = selectedWashers[selectedWashers.length - 1];
  const lastSelectedWasher = washersForFilter.find(washer => washer.washerEmployeeId === latestSelectedWasher)



  useEffect(() => {
    if (selectedDates?.length === 0 || selectedDates === null || selectedDates === undefined) {
      setIsDateSelected(false)
    } else {
      setIsDateSelected(true)
    }
  }, [selectedDates])
  return (
    <Box
      padding="25px"
      backgroundColor="white"
      borderTopRadius="base"
      boxShadow="primary"
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          <Heading title={T("bookings.table.title")} variant="bold" />
          <Box
            backgroundColor="input_border_color_primary"
            borderRadius="18px"
            padding="10px 12px"
            ml="30px"
            fontSize="base"
          >
            <Flex alignItems="center">
              <Text>{T("bookings.toolbar.box")}</Text>
              <Box
                ml="12px"
                mr="3px"
                w="12px"
                h="12px"
                borderRadius="50%"
                backgroundColor="success"
              ></Box>
              <Text fontSize="m">{boxTotals.availableBoxCount}</Text>
              <Box
                ml="12px"
                mr="3px"
                w="12px"
                h="12px"
                borderRadius="50%"
                backgroundColor="error"
              ></Box>
              <Text fontSize="m">{boxTotals.reservedBoxCount}</Text>
            </Flex>
          </Box>
        </Flex>
        <Flex alignItems="center" gap="20px" position="relative">
          {!isDateSelected &&
            <>
              <Text style={{
                position: "absolute",
                zIndex: 1,
                pointerEvents: "none",
                marginLeft: "9px",
                fontSize: "14px",
                color: "black",
                fontWeight: 500

              }}>{T("bookings.toolbar.choose_dates")}</Text>
              <Box style={{ position: "absolute", marginLeft: "170px", zIndex: 1, pointerEvents: "none" }}>
                <Icon name="calendar_month" iconStyles={{ width: "20px", height: "20px", }} />
              </Box>
            </>
          }

          <DateRangePicker
            propsConfigs={{
              triggerBtnProps: !isDateSelected && {
                color: "#FFF",
                _hover: {
                  backgroundColor: "#FFF"
                },
                _focus: {
                  backgroundColor: "#FFF"
                },

              }
            }}
            handleSelect={handleSelectDatesClick}
            selectedDates={selectedDates ? selectedDates : []} />

          <Menu closeOnSelect={false}>
            <MenuButton as={Button} style={{ backgroundColor: "white", color: "black", width: "100px", height: "44px", border: "2px solid #E9F2FD" }}>
              <Flex alignItems="center" justifyContent="space-between" gap="3">
                <Text style={{ fontSize: "14px" }}>{selectedBoxes.length > 0 ? lastSelectedItem : T("bookings.toolbar.box")}</Text>
                <Icon name="dropdown" iconStyles={{ fill: "#00000", width: "10px", height: "10px" }} />
              </Flex>
            </MenuButton>
            <MenuList minWidth='110px' overflowY="auto" maxHeight="300px">
              <MenuOptionGroup type='checkbox'>
                {arrayTransformedBoxCount.map((box: number) => (
                  <Checkbox
                    margin="12px 15px"
                    key={box}
                    isChecked={selectedBoxes.includes(box)}
                    onChange={() => handleBoxCountCheckbox(box)}
                    label={box.toString()}

                  />
                ))}
              </MenuOptionGroup>
            </MenuList>
          </Menu>
          <Menu closeOnSelect={false}>
            <MenuButton as={Button} style={{ backgroundColor: "white", color: "black", width: "120px", height: "44px", border: "2px solid #E9F2FD" }}>
              <Flex alignItems="center" justifyContent="space-between" gap="12">
                <Box style={{ minWidth: "40px" }}>
                  <Text style={{ fontSize: "11px" }}>{selectedWashers.length > 0 ? lastSelectedWasher?.washerEmployee.substring(0, 12) : T("bookings.toolbar.washers")}</Text>
                </Box>
                <Icon name="dropdown" iconStyles={{ fill: "#00000", width: "10px", height: "10px" }} />
              </Flex>
            </MenuButton>
            <MenuList minWidth='110px' overflowY="auto" maxHeight="300px"  >
              <MenuOptionGroup type='checkbox' p="4px 8px" m="2px 0">
                {washersForFilter?.map((washer: IWashersForFilter) => (
                  <Box key={washer.washerEmployeeId} style={{ margin: 0 }}>
                    <Checkbox
                      margin="12px 15px"
                      isChecked={selectedWashers?.includes(washer.washerEmployeeId)}
                      onChange={() => handleWashersFilter(washer.washerEmployeeId)}
                      label={washer.washerEmployee}
                    // value={statusGroup.count.toString()}
                    />
                  </Box>
                ))}
              </MenuOptionGroup>
            </MenuList>
          </Menu>
          <Menu closeOnSelect={false}>
            <MenuButton as={Button} style={{
              backgroundColor: "white",
              color: "black",
              height: "44px",
              width: "120px",
              border: "2px solid #E9F2FD",
              borderRadius: "10px"
            }}>
              <Flex alignItems="center" justifyContent="space-between" gap="10">
                <Box style={{ minWidth: "50px" }}>
                  <Text style={{ fontSize: "11px" }}>{selectedStatuses.length > 0 ? lastSelectedStatus?.statusText.substring(0, 12) : T("bookings.toolbar.status")}</Text>
                </Box>
                <Icon name="dropdown" iconStyles={{ fill: "#00000", width: "10px", height: "10px" }} />
              </Flex>

            </MenuButton>
            <MenuList minWidth='240px'>
              <MenuOptionGroup type='checkbox'>
                {statusGroups.map((statusGroup: IStatusGroup) => (
                  <Checkbox
                    margin="12px 15px"
                    key={statusGroup.status}
                    isChecked={selectedStatuses.includes(statusGroup.status)}
                    onChange={() => handleStatusCheckboxClick(statusGroup.status)}
                    label={statusGroup.statusText}
                    value={statusGroup.count.toString()}
                  />
                ))}
              </MenuOptionGroup>
            </MenuList>
          </Menu>
          <Menu closeOnSelect={false}>
            <MenuButton as={Button} style={{
              backgroundColor: "white",
              color: "black",
              height: "44px",
              width: "145px",
              border: "2px solid #E9F2FD",
              borderRadius: "10px"
            }}>
              <Flex alignItems="center" justifyContent="space-between" gap="20">
                <Box style={{ minWidth: "30px" }}>
                  <Text style={{ fontSize: "11px" }}>{selectedVehicleTypes.length > 0 ? lastSelectedCategory?.name.substring(0, 12) : T("bookings.toolbar.category")}</Text>
                </Box>
                <Icon name="dropdown" iconStyles={{ fill: "#00000", width: "10px", height: "10px" }} />
              </Flex>

            </MenuButton>
            <MenuList minWidth='240px'>
              <MenuOptionGroup type='checkbox'>
                {vehicleBodyTypeGroups.map((vehicleBodyTypeGroup: IVehicleBodyTypeGroups) => (
                  <Checkbox
                    margin="12px 15px"
                    key={vehicleBodyTypeGroup.id}
                    isChecked={selectedVehicleTypes.includes(vehicleBodyTypeGroup.id)}
                    onChange={() => handleVehicleTypeCheckBox(vehicleBodyTypeGroup.id)}
                    label={vehicleBodyTypeGroup.name}
                    value={vehicleBodyTypeGroup.count.toString()}
                  />
                ))}
              </MenuOptionGroup>
            </MenuList>
          </Menu>

          <Box style={{ cursor: "pointer" }} onClick={() => handleClearAllFilters()}>
            <Flex style={{
              backgroundColor: "#046CEC1A",
              height: "44px",
              width: "44px",
              borderRadius: "100px",
              justifyContent: "center",
              alignItems: "center"
            }}>
              <Icon name="delete_forever" iconStyles={{ width: "20px", height: "20px", }} />
            </Flex>
          </Box>
        </Flex>
      </Flex>
    </Box>
  )
}

export default ReservationsToolbar
